<template>
  <section v-if="!isPageLoading" class="learning-area">
    <div
      class="learning-area__background"
      :style="
        `background-image: url(${backgroundImg(
          currentCategory.name
        )}), linear-gradient(#151515, #262626);`
      "
    >
      <div class="learning-area__overlay"></div>
    </div>
    <article class="learning-area__category">
      <div class="learning-area__details-wrapper">
        <h4 class="learning-area__type content-type">learning area</h4>
        <h4 class="learning-area__title content-title">
          {{ currentCategory.name }}
        </h4>
        <p class="learning-area__description content-description">
          {{ currentCategory.description }}
        </p>
      </div>
      <LearningAreaFilteredCourses
        :category="currentCategory"
        :popularCourses="popularCourses"
        :categoryNewCourses="categoryNewCourses"
        class="learning-area__filtered-courses"
      ></LearningAreaFilteredCourses>
      <div class="learning-area__search-wrapper">
        <h6 class="learning-area__search-category">
          {{ currentCategory.name }} Courses
        </h6>
        <SearchResults
          class="learning-area__search-results"
          :customFacet="{
            type: 'all_categories.name',
            value: currentCategory.name,
          }"
        ></SearchResults>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import LearningAreaFilteredCourses from '@/components/category/LearningAreaFilteredCourses.vue'
import SearchResults from '@/components/search/SearchResults.vue'

export default {
  name: 'LearningArea',
  props: {
    pushedQuery: {
      type: String,
      required: false,
    },
  },
  components: {
    SearchResults,
    LearningAreaFilteredCourses,
  },
  computed: {
    ...mapGetters({
      isPageLoading: 'app/isPageLoading',
      currentCategory: 'categories/currentCategory',
      popularCourses: 'categories/currentCategoryPopularCourses',
      categoryNewCourses: 'categories/currentCategoryNewCourses',
    }),
  },
  methods: {
    backgroundImg(name) {
      const url =
        'https://s3.amazonaws.com/my.ine.com/assets/learning-areas/heroes/'
      switch (name) {
        case 'DevOps':
          return `${url}devops.jpg`
        case 'Cloud':
          return `${url}devops.jpg`
        case 'Networking':
          return `${url}networking.jpg`
        case 'Development':
          return `${url}development.jpg`
        case 'Security':
          return `${url}security.jpg`
        case 'General IT':
          return `${url}general.jpg`
        case 'Data Science':
          return `${url}data_science.jpg`
        default:
          return `${url}devops.jpg`
      }
    },
  },
  async created() {
    this.$store.dispatch('app/setIsPageLoading', true)
    await this.$store.dispatch('search/setSearchQuery', '')
    await this.$store.dispatch('categories/getCategory', this.$route.params.id)
    await this.$store.dispatch(
      'categories/getCategoryPopularCourses',
      this.$route.params.id
    )
    await this.$store.dispatch(
      'categories/getCategoryNewCourses',
      this.$route.params.id
    )
    this.$store.dispatch('app/setIsPageLoading', false)
  },
}
</script>

<style lang="scss" scoped>
.learning-area {
  background-color: var(--dark-gray);
  position: relative;
  &__background {
    width: 100%;
    height: 100vh;
    position: absolute;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: top;
    z-index: 0;
    @include mobile {
      background-position: center;
    }
  }
  &__overlay {
    position: relative;
    background: linear-gradient(
      to bottom,
      rgba(0, 0, 0, 0),
      rgba(0, 0, 0, 0.2),
      rgba(0, 0, 0, 0.4),
      var(--dark-gray),
      var(--dark-gray)
    );
    height: 100%;
    width: 100%;
    z-index: 0;
  }
  &__category {
    position: relative;
    padding: 150px 25px 0 25px;
    color: var(--white);
    @include tablet {
      padding: 150px 75px;
    }
  }
  &__title {
    font-size: 2.5rem;
  }
  &__description {
    color: var(--white);
    padding-bottom: 100px;
    font-size: 1.2rem;
    @include mobile {
      width: 50%;
    }
  }
  &__search-category {
    font-size: 2rem;
  }
}
</style>
